module.exports = __webpack_public_path__ + "static/media/hab8-0.79151c6c.jpg";